import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { isItDeveloper } from '@/lib/itSupport';
import { getHomePathByRole } from '@/lib/appNav';
import PageLoader from '@/components/base/PageLoader';

interface ItDeveloperGuardProps {
  /** フラグ非保有者をリダイレクトする先（省略時はロール別ホーム）。 */
  redirectTo?: string;
}

/**
 * IT開発者フラグ（profiles.is_it_developer）保有者だけを通すアクセスガード。
 * RoleGuard（ロール単位）/ ItStaffGuard（IT管理者 or IT開発者）より厳しく、
 * 「IT開発者だけ」に限定したい専用ツール（ユーザーログ一覧など）で使う。
 * AuthGuard の内側（＝ログイン済み）で使用する。
 */
export default function ItDeveloperGuard({ redirectTo }: ItDeveloperGuardProps) {
  const { profile, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (!profile || !isItDeveloper(profile)) {
    return <Navigate to={redirectTo || getHomePathByRole(profile?.role)} replace />;
  }

  return <Outlet />;
}